var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLoading = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.156 12.844c-0.466 0-0.844-0.377-0.844-0.844 0-1.392-0.272-2.742-0.811-4.015-0.547-1.274-1.293-2.362-2.21-3.279l-0-0c-0.916-0.919-2.004-1.664-3.212-2.185l-0.067-0.026c-1.27-0.537-2.62-0.809-4.013-0.809-0.466 0-0.844-0.377-0.844-0.844s0.377-0.844 0.844-0.844c1.62 0 3.192 0.316 4.671 0.945 1.43 0.602 2.712 1.47 3.813 2.571s1.966 2.386 2.571 3.813c0.626 1.479 0.942 3.052 0.942 4.671 0.002 0.466-0.375 0.844-0.841 0.844z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoading, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/loading.f5b2293e.svg";
export { ForwardRef as ReactComponent };